import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const PATH_TITLES = [
  { prefix: '/admin/settings', title: 'Ayarlar' },
  { prefix: '/admin/system-diagnostics', title: 'Sistem tanıları' },
  { prefix: '/admin/activity-feed-settings', title: 'Canlılık ve Feed' },
  { prefix: '/admin/audit', title: 'Audit Log' },
  { prefix: '/admin/boxes', title: 'Kutu Operasyonları' },
  { prefix: '/admin/activation-codes', title: 'Aktivasyon Kodları' },
  { prefix: '/admin/progression', title: 'Progression' },
  { prefix: '/admin/missions', title: 'Görevler' },
  { prefix: '/admin/avatars', title: 'Avatarlar' },
  { prefix: '/admin/users', title: 'Kullanıcılar' },
  { prefix: '/admin/card-templates', title: 'Kart şablonları' },
  { prefix: '/admin/characters', title: 'Karakterler' },
  { prefix: '/admin/series', title: 'Seriler' },
  { prefix: '/admin', title: 'Yönetim Merkezi' },
];

function titleForPath(pathname) {
  const hit = PATH_TITLES.find((p) => pathname === p.prefix || pathname.startsWith(`${p.prefix}/`));
  return hit?.title ?? 'Admin';
}

/**
 * Masaüstü üst şerit — breadcrumb benzeri başlık.
 */
export default function AdminTopBar() {
  const { pathname } = useLocation();
  const title = useMemo(() => titleForPath(pathname), [pathname]);

  return (
    <div
      className="hidden md:flex md:items-center md:justify-between md:gap-4 md:px-8 md:py-3 md:border-b md:border-white/10 md:bg-background/80 md:backdrop-blur-md md:sticky md:top-0 md:z-30"
      data-testid="admin-top-bar"
    >
      <div className="min-w-0">
        <p className="text-[10px] uppercase tracking-wider text-violet-400/90 font-semibold">Yönetim</p>
        <h2 className="text-lg font-black text-white truncate" style={{ fontFamily: 'Cinzel, serif' }}>
          {title}
        </h2>
      </div>
    </div>
  );
}
